import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import config from './aws-exports';
import { ThemeProvider, CssBaseline } from '@mui/material';
import getAppTheme from './theme/appTheme';
// import './theme/corporate.css'; // Disabled - using regular theme for all modes
import { installApiInterceptor } from './services/authApi';

Amplify.configure(config);

// Install API interceptor for automatic token management and refresh
installApiInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));

const isCorporateMode = process.env.REACT_APP_CORPORATE_MODE === 'true';
const theme = getAppTheme(false); // Always use regular theme

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();